export const setTrainerTabTitle = (
    projectName: string,
    target: Pick<Document, "title"> = document,
): void => {
    target.title = projectName;
};
